<template lang="pug">
	//- Ошибка запуска превью креатива: предлагаем отправить агенту запрос на исправление (локальное сообщение, не сохраняется в чате)
	.ai-chat-message.assistant.preview-error
		.ai-chat-message-content.ai-chat-preview-error
			.ai-chat-preview-error-text
				i.fa.fa-exclamation-triangle
				span The preview failed with an error{{error.count > 1 ? ` (${error.count} errors)` : ''}}. Do you want the AI agent to fix it?
			.ai-chat-preview-error-details {{getDescription()}}
			.ai-chat-preview-error-actions
				button.btn.btn-primary.btn-sm(type="button" :disabled="thinking" v-on:click="$emit('fix')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Send the error to the AI agent and ask to fix it'}")
					i.fa.fa-magic
					span Ask AI to fix
				button.btn.btn-ghost-light.btn-sm(type="button" v-on:click="$emit('dismiss')")
					span Dismiss
</template>

<script>
	import { AIAgent } 			from './../../services/AIAgent'

	export default {
		name: "AIAgentPreviewError",
		// error - первая ошибка загрузки фрейма превью {message, source, line, column, stack, count}, thinking - агент сейчас работает
		props: ['error', 'thinking'],
		methods: {
			getDescription() {

				return AIAgent.getPreviewErrorDescription(this.error);

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-message
				// Ошибка запуска превью с предложением исправить её ИИ агентом
				&.preview-error
					.ai-chat-preview-error
						background-color: rgba(248,108,107,0.12)
						border: 1px solid #f86c6b

					.ai-chat-preview-error-text
						display: flex
						flex-direction: row
						align-items: baseline
						gap: 8px

						i.fa
							color: #f86c6b

					.ai-chat-preview-error-details
						margin-top: 6px
						max-height: 80px
						overflow: auto
						font-family: monospace
						font-size: 11px
						color: #adb6bf
						word-break: break-all
						user-select: text

					.ai-chat-preview-error-actions
						display: flex
						flex-direction: row
						gap: 8px
						margin-top: 8px

						.btn i.fa
							margin-right: 6px

</style>
